import { render } from "./CreatePlanForm.vue?vue&type=template&id=6b3495b6&scoped=true"
import script from "./CreatePlanForm.vue?vue&type=script&lang=js"
export * from "./CreatePlanForm.vue?vue&type=script&lang=js"

import "./CreatePlanForm.vue?vue&type=style&index=0&id=6b3495b6&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3495b6"]])

export default __exports__